import { platformStrMap } from "@/views/takeaway/constants"

const state = {
  platform: 'MT'
}

const getters = {
  platform: (state) => state.platform,
  platformStr: (state) => platformStrMap[state.platform],
}

const mutations = {
  SET_PLATFORM(state, platform) {
    state.platform = platform
  }
}

const actions = {
  setPlatform({ commit }, platform) {
    commit('SET_PLATFORM', platform)
  }
}

export default { state, getters, mutations, actions }
